const React = require('react');
const ReactIntl = require('react-intl');
const _ = require('lodash');

const { Separator } = require('@metro-ui/core');
const { Button, Input } = require("metro-ui-components");

const PageCase = require("../PageCase/PageCase.js");
const Header = require("../Header/Header");
const Footer = require("../Footer/Footer");
const LoginBoxWrapper = require("../LoginBoxWrapper/LoginBoxWrapper.js");
const PasswordField = require("../Password/PasswordField.js");

const LoginStore = require("../../stores/LoginStore");
const LoginActions = require('../../actions/LoginActions.js');

const defaultMessages = require('../../i18n/messages/default');
const urlUtils = require('../../utils/urlUtils.js');
const Constants = require('../../constants/AppConstants');

const { injectIntl, IntlProvider } = ReactIntl;
class LinkAccount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            localeId: 'en-GB',
            forgotPwdLinkUrl: '',
            email: '',
            password: '',
            redirectUri: ''
        };

        this.onLocalChange = this.onLocalChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onLinkHDAccountListener = this.onLinkHDAccountListener.bind(this);
    }

    getQueryParamsMapped() {
        const rawQueryData = urlUtils.getParameterByName('data', window.location.href)
        const queryData = JSON.parse(rawQueryData)

        return {
            email: queryData['externalId'],
            userId: queryData['idamUserId'],
            clientId: urlUtils.getParameterByName(Constants.UrlParams.CLIENT_ID),
            localeId: urlUtils.getParameterByName(Constants.UrlParams.LOCALE_ID),
            realmId: urlUtils.getParameterByName(Constants.UrlParams.REALM_ID),
            userType: urlUtils.getParameterByName(Constants.UrlParams.USER_TYPE),
            redirectUrl: urlUtils.getParameterByName(encodeURIComponent(Constants.UrlParams.REDIRECT_URI)),
            responseType: urlUtils.getParameterByName(Constants.UrlParams.RESPONSE_TYPE),
            scope: urlUtils.getParameterByName(Constants.UrlParams.SCOPE),
            nonce: urlUtils.getParameterByName(Constants.UrlParams.NONCE),
            countryCode: urlUtils.getParameterByName(Constants.UrlParams.COUNTRY_CODE),
            state: urlUtils.getParameterByName(Constants.UrlParams.STATE),
            accountId: urlUtils.getParameterByName(Constants.UrlParams.ACCOUNT_ID),
            traceId: urlUtils.getParameterByName(Constants.UrlParams.TRACE_ID),
            preview: urlUtils.getParameterByName(Constants.UrlParams.PREVIEW),
            codeChallenge: urlUtils.getParameterByName(Constants.UrlParams.CODE_CHALLENGE),
            codeChallengeMethod: urlUtils.getParameterByName(Constants.UrlParams.CODE_CHALLENGE_METHOD),
        }
    }

    componentDidMount() {
        LoginStore.addLinkHDAccountListener(this.onLinkHDAccountListener);

        const linkAccountUriData = this.getQueryParamsMapped()
        let appState = LoginStore.getState();

        const forgotPasswordLink = appState.forgotPasswordLinkUrl
            ? appState.forgotPasswordLinkUrl
            : urlUtils.formForgotPwdLinkUrl(linkAccountUriData, linkAccountUriData.localeId);

        this.setState({ ...linkAccountUriData, forgotPwdLinkUrl: forgotPasswordLink });
    }

    onEmailChange(_, email) {
        this.setState({ email });
    }

    onPasswordChange(password) {
        this.setState({ password });
    }

    onLinkHDAccountListener() {
        const appState = LoginStore.getState();
        const { linkAccount: { error, responseCode } } = appState;

        if (error) {
            switch (responseCode) {
                case 401:
                    LoginActions.triggerToast(
                        this.props.intl.formatMessage(defaultMessages['invalid_credentials']),
                        "error", true);
                    break;
                case 403:
                    LoginActions.triggerToast(
                        this.props.intl.formatMessage(defaultMessages['linkAccount.error.source_system_message']),
                        "error", true);
                    break;
                case 404:
                    LoginActions.triggerToast(
                        this.props.intl.formatMessage(defaultMessages['invalid.email.address']),
                        "error", true);
                    break;
                case 500:
                    LoginActions.triggerToast(
                        this.props.intl.formatMessage(defaultMessages['badrequest']),
                        "error", true);
                    break;
            }
        } else {
            LoginActions.triggerToast(
                this.props.intl.formatMessage(defaultMessages['success']),
                "success", true);
            window.location = this.state.redirectUri
        }
    }

    onLinkAccount(event) {
        const { password, email, userId } = this.state;
        event.preventDefault();

        if (!this.state.password) {
            return
        }

        const sourceSystem = urlUtils.getParameterByName('source_system');
        const redirectUri = urlUtils.getParameterByName('redirect_uri') || 'https://www.metro.com';

        this.setState({ redirectUri })
        // @todo Fix userId
        LoginActions.submitLinkHDAccount(email, password, email, sourceSystem);
    }

    onLocalChange(localeId) {
        this.setState({ localeId });
    }

    componentWillUnmount() {
        LoginStore.removeLinkHDAccountListener(this.onLinkHDAccountListener)
    }

    renderLinkAccountContent() {
        const { intl: { formatMessage } } = this.props;

        return (
            <div>
                <div className="linkAccount container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer newDesign larger-device-width smaller-device">
                            <div className="col-xs-12 smaller-device-inside-wrap loginCard">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="form-group centreAligned loginHeader">
                                            <span>{formatMessage(defaultMessages["linkAccount.title"])}</span>
                                        </div>
                                    </div>
                                </div>
                                <LoginBoxWrapper>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group centreAligned">
                                                <span>{formatMessage(defaultMessages["linkAccount.email_text"])}</span>
                                                <p className="email">{this.state.email}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group centreAligned textWrapper">
                                                <span>{formatMessage(defaultMessages["linkAccount.password_text_1"])}</span>
                                                <span>{` ${this.props.clientId} `}</span>
                                                <span>{formatMessage(defaultMessages["linkAccount.password_text_2"])}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <form
                                            id="authForm"
                                            noValidate="novalidate"
                                            onSubmit={(event) => { this.onLinkAccount(event) }}
                                            autoComplete="off"
                                        >
                                            <PasswordField
                                                {...this.props}
                                                onPasswordChange={this.onPasswordChange}
                                                forgotPasswordLinkUrl={formatMessage(defaultMessages["linkAccount.password_link"])}
                                                onLinkClick={() => window.open(this.state.forgotPwdLinkUrl, '_blank')}
                                            />
                                            <Button
                                                id="submit"
                                                type="submit"
                                                value="submit"
                                                kind="primaryRaised"
                                                size="large"
                                                className="primary-button"
                                                almostActive={!this.state.password}
                                            >
                                                {formatMessage(defaultMessages["linkAccount.action"])}
                                            </Button>
                                        </form>
                                        <div className="separatorWidth">
                                            <Separator />
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div className="form-group centreAligned linksText">
                                                    <span>{`${formatMessage(defaultMessages["linkAccount.terms_1"])} `}</span>
                                                    <a href={Constants.SOCIAL_LOGIN.DISH_CONSTANTS.termsAndConditionsLink}>
                                                        {formatMessage(defaultMessages["linkAccount.terms_2"])}
                                                    </a>
                                                    <span>{` ${formatMessage(defaultMessages["linkAccount.terms_3"])} `}</span>
                                                    <a href={Constants.SOCIAL_LOGIN.DISH_CONSTANTS.privacyPolicyLink}>
                                                        {formatMessage(defaultMessages["linkAccount.terms_4"])}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </LoginBoxWrapper>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
            </div>
        );
    }

    renderLinkExistingAccountContent() {
        const { intl: { formatMessage } } = this.props;

        return (
            <div>
                <div className="linkAccount container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer newDesign larger-device-width smaller-device">
                            <div className="col-xs-12 smaller-device-inside-wrap loginCard">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="form-group centreAligned loginHeader">
                                            <span>{formatMessage(defaultMessages["linkExistingAccount.title"])}</span>
                                        </div>
                                    </div>
                                </div>
                                <LoginBoxWrapper>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group centreAligned existingAccountTextWrapper">
                                                <span>{formatMessage(defaultMessages["linkExistingAccount.subtitle"])}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <form
                                            id="authForm"
                                            noValidate="novalidate"
                                            onSubmit={(event) => this.onLinkAccount(event)}
                                            autoComplete="off"
                                        >
                                            <Input
                                                id="user_id"
                                                type="email"
                                                key="user_id"
                                                name="user_id"
                                                autoComplete="off"
                                                label={formatMessage(defaultMessages["linkExistingAccount.email"])}
                                                value={this.state.email}
                                                onChange={this.onEmailChange}
                                                onKeyUp={this.onEmailChange}
                                                onKeyDown={this.onEmailChange}
                                                required
                                                autoFocus
                                            />
                                            <PasswordField
                                                {...this.props}
                                                onPasswordChange={this.onPasswordChange}
                                            />
                                            <Button
                                                id="submit"
                                                type="submit"
                                                value="submit"
                                                kind="primaryRaised"
                                                size="large"
                                                className="primary-button"
                                                almostActive={!this.state.password || !this.state.email}
                                            >
                                                {formatMessage(defaultMessages["linkAccount.action"])}
                                            </Button>
                                        </form>
                                        <div className="passwordLinkWrapper">
                                            <a onClick={() => window.open(this.state.forgotPwdLinkUrl, '_blank')}>Forgot Password?</a>
                                        </div>
                                        <div className="separatorWidth">
                                            <Separator />
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div className="form-group centreAligned linksText">
                                                    <span>{`${formatMessage(defaultMessages["linkAccount.terms_1"])} `}</span>
                                                    <a href={Constants.SOCIAL_LOGIN.DISH_CONSTANTS.termsAndConditionsLink}>
                                                        {formatMessage(defaultMessages["linkAccount.terms_2"])}
                                                    </a>
                                                    <span>{` ${formatMessage(defaultMessages["linkAccount.terms_3"])} `}</span>
                                                    <a href={Constants.SOCIAL_LOGIN.DISH_CONSTANTS.privacyPolicyLink}>
                                                        {formatMessage(defaultMessages["linkAccount.terms_4"])}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </LoginBoxWrapper>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
            </div>
        );
    }

    renderFooter() {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}
            >
                <div className="fixFooterBottom">
                    <Footer
                        {...this.props}
                        locale={this.state.localeId}
                        onLocalChange={this.onLocalChange}
                    />
                </div>
            </IntlProvider>
        );
    };

    render() {
        const { userId } = this.state;

        return (
            <PageCase
                header={<Header removeNavbar />}
                content={userId ? this.renderLinkAccountContent() : this.renderLinkExistingAccountContent()}
                footer={this.renderFooter()}
            />
        );
    }
}

module.exports = injectIntl(LinkAccount);